// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"260":"publishers","687":"agenda","797":"event"}[chunkId] + "." + {"260":"1da633e2","687":"1192aced","797":"8d2dc8b5"}[chunkId] + ".css";
};